import {Page} from '../models/Page';
import {signal} from '@angular/core';

export class InfiniteScroll {
  static onScroll(e: any, limitReached: () => void) {
    const tableViewHeight = e.target.offsetHeight; // viewport
    const tableScrollHeight = e.target.scrollHeight; // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled

    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;

    if (scrollLocation > limit) {
      limitReached();
    }
  }
}

export class InfiniteScrollDataSource<T> {
  public isLoading = signal(false)
  public data = signal<T[]>([])

  private lastPage?: Page<T>
  private _pendingReload = false;

  constructor(
    private readonly loader: (pageNumber?: number) => Promise<Page<T>>) {
  }

  private _dataEndVisible = false;

  public set dataEndVisible(value: boolean) {
    if (!this._dataEndVisible && value) {
      this.loadData(true).then();
    }
    this._dataEndVisible = value;
  }

  public reload() {
    this.loadData(false).then()
  }

  private async loadData(loadMore: boolean) {
    if (this.isLoading() || (loadMore && this.lastPage?.last)) {
      if (!loadMore) {
        this._pendingReload = true;
      }
      return
    }
    this.isLoading.set(true);
    if (!loadMore) {
      this.data().length = 0;
    }

    const page = loadMore ? this.lastPage.number + 1 : 0;
    const result = await this.loader(page);

    this.lastPage = result;
    this.data().push(...result.content);

    this.isLoading.set(false);
    if (this._pendingReload) {
      this._pendingReload = false;
      this.loadData(false).then()
    } else if (this._dataEndVisible) {
      this.loadData(true).then();
    }
  }
}
